import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute } from '@tanstack/react-router';
import { Tabs } from 'antd';
import { CreditCard } from 'lucide-react';
import { PaymentProcesses } from './PaymentProcesses';
import { PaymentUsers } from './PaymentUsers';

export const Route = createFileRoute('/console/$orgId/configuration/financials/payments')({
    staticData: {
        metadata: {
            title: 'Payments',
        },
        ui: {
            icon: CreditCard,
            title: 'Payments configuration',
            subtitle: 'Configure payment processes and users',
            menuDescription: 'Configure payment processes and users',
        },
        modules: ['claim'],
        permissions: ['settings:update'],
    },
    component: ConfigurationPayments,
});

function ConfigurationPayments() {
    return (
        <PageController route={Route}>
            <Tabs
                type="line"
                defaultActiveKey="processes"
                items={[
                    {
                        key: 'processes',
                        label: 'Payment processes',
                        children: <PaymentProcesses />,
                    },
                    {
                        key: 'users',
                        label: 'Payment users',
                        children: <PaymentUsers />,
                    },
                ]}
            />
        </PageController>
    );
}
